import { useState } from 'react';
import {
  authProviderContent,
  AuthProviderId,
  DetermineSingleSignOnResponseModel,
  SingleSignOnProps,
  SsoProviderOption,
} from './UserModels';
import { api, buildUrl } from '#shared/ApiClient';
import { Button } from '#shared/components/Button';

function SingleSignOn({ onRequestEmailPassword, lastLoginEmailAddress }: SingleSignOnProps) {
  const [emailAddress, setEmailAddress] = useState(lastLoginEmailAddress || '');
  const [submitted, setSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [ssoProviders, setSsoProviders] = useState<SsoProviderOption[]>([]);
  const [ssoSignInAllowed, setSsoSignInAllowed] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    // TODO for this submit -- if there is only 1 match -- we take them to that sign in screen
    // If there are more than one...we see the SSO page with all options
    event.preventDefault();
    setSubmitted(true);

    const urlParams = new URLSearchParams(globalThis.location.search);
    const returnUrl = urlParams.get('ReturnUrl');
    const result: DetermineSingleSignOnResponseModel = await api.post('SignIn/DetermineSingleSignOn', {
      emailAddress,
      returnUrl,
    });

    if (result.RedirectUrl) {
      MixpanelTracking?.trackPageLoad(result.RedirectUrl);
      globalThis.location.href = result.RedirectUrl;
    } else {
      setSsoProviders(result.SsoProviders);
      setSsoSignInAllowed(true);
    }

    if (result.ErrorMessage) {
      setErrorMessage(result.ErrorMessage);
      setSsoSignInAllowed(false);
    }

    setSubmitted(false);
  };

  const onSsoClick = (provider: SsoProviderOption) => {
    const urlParams = new URLSearchParams(globalThis.location.search);
    const returnUrl = urlParams.get('ReturnUrl') || '';
    MixpanelTracking?.trackPageLoad(returnUrl);
    const loginParams = new URLSearchParams({
      emailAddress,
      returnUrl,
    });
    if (provider.AccountGroupId != null) {
      loginParams.set('accountGroupId', String(provider.AccountGroupId));
    }
    globalThis.location.href = buildUrl(`AuthenticationProviders/Login?${loginParams.toString()}`);
  };

  const getAuthProviderContentForId = (id: number) => {
    const content = authProviderContent[id as AuthProviderId];
    if (!content) {
      return { text: `Unknown ID: ${id}`, icon: '' };
    }
    return content;
  };

  return (
    <form method="post" onSubmit={handleSubmit}>
      {ssoSignInAllowed ? (
        <>
          <div className="welcome-sso-user">
            <span>Welcome {emailAddress}</span>
            <Button className="link-btn" type="button" onClick={() => setSsoSignInAllowed(false)}>
              Change?
            </Button>
          </div>
          <div className="sso-button-group">
            {ssoProviders.map((provider) => {
              const { text, icon } = getAuthProviderContentForId(provider.AuthenticationProviderId);

              return (
                <Button
                  type="button"
                  className="btn-glow secondary"
                  key={provider.AuthenticationProviderId}
                  onClick={() => onSsoClick(provider)}
                >
                  {icon && (
                    <img
                      src={buildUrl(icon)}
                      alt={`${text} icon`}
                      style={{ width: '28px', height: '28px', flexShrink: 0, aspectRatio: '1/1', marginRight: '15px' }}
                    />
                  )}
                  Sign in with {text}
                </Button>
              );
            })}
          </div>
        </>
      ) : (
        <>
          <div className="mb-4">
            <input
              className="form-control w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              id="EmailAddress"
              name="EmailAddress"
              required
              placeholder="Email address"
              type="text"
              value={emailAddress}
              onChange={(e) => {
                setEmailAddress(e.target.value);
                setErrorMessage('');
              }}
            />
          </div>
          {errorMessage && <div className="error-message">{errorMessage}</div>}
          <Button type="submit" className="btn-glow primary signup" disabled={submitted}>
            Next
          </Button>
        </>
      )}
      <div className="or-separator">OR</div>
      <Button type="button" className="btn-glow secondary signup" disabled={submitted} onClick={onRequestEmailPassword}>
        Use password instead
      </Button>
    </form>
  );
}

export default SingleSignOn;
